import api from './client';

export const documentsApi = {
  list: (params) => api.get('/documents', { params }).then(r => r.data),
  getForRecord: (recordId) => api.get('/documents/record/' + recordId).then(r => r.data),

  upload: (file, recordId, category, description) => {
    const fd = new FormData();
    fd.append('file', file);
    if (recordId) fd.append('record_id', recordId);
    if (category) fd.append('category', category);
    if (description) fd.append('description', description);
    return api.post('/documents/upload', fd, {
      headers: { 'Content-Type': 'multipart/form-data' },
    }).then(r => r.data);
  },

  uploadMultiple: (files, recordId, category) => {
    const fd = new FormData();
    files.forEach(f => fd.append('files', f));
    if (recordId) fd.append('record_id', recordId);
    if (category) fd.append('category', category);
    return api.post('/documents/upload-multiple', fd, {
      headers: { 'Content-Type': 'multipart/form-data' },
    }).then(r => r.data);
  },

  getDownloadUrl: (id) => api.get('/documents/' + id + '/download').then(r => r.data),
  getPreviewUrl: (id) => api.get('/documents/' + id + '/preview').then(r => r.data),
  update: (id, data) => api.put('/documents/' + id, data).then(r => r.data),
  delete: (id) => api.delete('/documents/' + id).then(r => r.data),

  // OCR + AI Processing
  processDocument: (id, recordId) => api.post('/documents/' + id + '/process', { record_id: recordId }).then(r => r.data),
  getOcrResults: (id) => api.get('/documents/' + id + '/ocr').then(r => r.data),
  bulkProcess: (documentIds, recordId) => api.post('/documents/bulk-process', { document_ids: documentIds, record_id: recordId }).then(r => r.data),
};
